import { colors } from './colors';
import { spaceProps } from './spaceProps';
import { textStyles } from './textStyles';
import { fontFaces } from './fontFaces';
import { fontMetrics } from './fontMetrics';

export { colors, spaceProps, textStyles, fontFaces, fontMetrics };
